import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import { css } from '@emotion/react';
import { designTokens } from '@commercetools-uikit/design-system';
import { jsx } from '@emotion/react/jsx-runtime';

// @TODO remove this when we deprecate `flexStart`/`flexEnd`
const getAlignItem = alignment => {
  switch (alignment) {
    case 'flexStart':
      return `flex-start`;
    case 'flexEnd':
      return `flex-end`;
    default:
      return alignment;
  }
};
const getMargin = scale => {
  switch (scale) {
    case 'xs':
      return designTokens.spacing10;
    case 's':
      return designTokens.spacing20;
    case 'm':
      return designTokens.spacing30;
    case 'l':
      return designTokens.spacing40;
    case 'xl':
      return designTokens.spacing50;
    case 'xxl':
      return designTokens.spacing60;
    case 'xxxl':
      return designTokens.spacing70;
    default:
      return 0;
  }
};

/**
 * We need to force the margin for the child elements as ome children
 * might have `margin: 0` defined, which results in a higher CSS specificity,
 * causing the margings of the spacing components to be ignored.
 * See https://github.com/commercetools/ui-kit/issues/542
 */
const getStyles = props => /*#__PURE__*/css("display:flex;align-items:", getAlignItem(props.alignItems), ";justify-content:", props.justifyContent, ";>*+*{margin:0 0 0 ", getMargin(props.scale), "!important;}" + (process.env.NODE_ENV === "production" ? "" : ";label:getStyles;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlubGluZS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBNEM4QyIsImZpbGUiOiJpbmxpbmUuc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBUQWxpZ25JdGVtLCBUSW5saW5lUHJvcHMsIFRTY2FsZSB9IGZyb20gJy4vaW5saW5lJztcblxuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgZGVzaWduVG9rZW5zIH0gZnJvbSAnQGNvbW1lcmNldG9vbHMtdWlraXQvZGVzaWduLXN5c3RlbSc7XG5cbi8vIEBUT0RPIHJlbW92ZSB0aGlzIHdoZW4gd2UgZGVwcmVjYXRlIGBmbGV4U3RhcnRgL2BmbGV4RW5kYFxuY29uc3QgZ2V0QWxpZ25JdGVtID0gKGFsaWdubWVudD86IFRBbGlnbkl0ZW0pID0+IHtcbiAgc3dpdGNoIChhbGlnbm1lbnQpIHtcbiAgICBjYXNlICdmbGV4U3RhcnQnOlxuICAgICAgcmV0dXJuIGBmbGV4LXN0YXJ0YDtcbiAgICBjYXNlICdmbGV4RW5kJzpcbiAgICAgIHJldHVybiBgZmxleC1lbmRgO1xuICAgIGRlZmF1bHQ6XG4gICAgICByZXR1cm4gYWxpZ25tZW50O1xuICB9XG59O1xuXG5jb25zdCBnZXRNYXJnaW4gPSAoc2NhbGU/OiBUU2NhbGUpOiBzdHJpbmcgfCBudW1iZXIgPT4ge1xuICBzd2l0Y2ggKHNjYWxlKSB7XG4gICAgY2FzZSAneHMnOlxuICAgICAgcmV0dXJuIGRlc2lnblRva2Vucy5zcGFjaW5nMTA7XG4gICAgY2FzZSAncyc6XG4gICAgICByZXR1cm4gZGVzaWduVG9rZW5zLnNwYWNpbmcyMDtcbiAgICBjYXNlICdtJzpcbiAgICAgIHJldHVybiBkZXNpZ25Ub2tlbnMuc3BhY2luZzMwO1xuICAgIGNhc2UgJ2wnOlxuICAgICAgcmV0dXJuIGRlc2lnblRva2Vucy5zcGFjaW5nNDA7XG4gICAgY2FzZSAneGwnOlxuICAgICAgcmV0dXJuIGRlc2lnblRva2Vucy5zcGFjaW5nNTA7XG4gICAgY2FzZSAneHhsJzpcbiAgICAgIHJldHVybiBkZXNpZ25Ub2tlbnMuc3BhY2luZzYwO1xuICAgIGNhc2UgJ3h4eGwnOlxuICAgICAgcmV0dXJuIGRlc2lnblRva2Vucy5zcGFjaW5nNzA7XG4gICAgZGVmYXVsdDpcbiAgICAgIHJldHVybiAwO1xuICB9XG59O1xuXG4vKipcbiAqIFdlIG5lZWQgdG8gZm9yY2UgdGhlIG1hcmdpbiBmb3IgdGhlIGNoaWxkIGVsZW1lbnRzIGFzIG9tZSBjaGlsZHJlblxuICogbWlnaHQgaGF2ZSBgbWFyZ2luOiAwYCBkZWZpbmVkLCB3aGljaCByZXN1bHRzIGluIGEgaGlnaGVyIENTUyBzcGVjaWZpY2l0eSxcbiAqIGNhdXNpbmcgdGhlIG1hcmdpbmdzIG9mIHRoZSBzcGFjaW5nIGNvbXBvbmVudHMgdG8gYmUgaWdub3JlZC5cbiAqIFNlZSBodHRwczovL2dpdGh1Yi5jb20vY29tbWVyY2V0b29scy91aS1raXQvaXNzdWVzLzU0MlxuICovXG5jb25zdCBnZXRTdHlsZXMgPSAocHJvcHM6IFRJbmxpbmVQcm9wcykgPT4gY3NzYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogJHtnZXRBbGlnbkl0ZW0ocHJvcHMuYWxpZ25JdGVtcyl9O1xuICBqdXN0aWZ5LWNvbnRlbnQ6ICR7cHJvcHMuanVzdGlmeUNvbnRlbnR9O1xuXG4gID4gKiArICoge1xuICAgIG1hcmdpbjogMCAwIDAgJHtnZXRNYXJnaW4ocHJvcHMuc2NhbGUpfSAhaW1wb3J0YW50O1xuICB9XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBnZXRTdHlsZXM7XG4iXX0= */");
var getStyles$1 = getStyles;

function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
const Inline = props => jsx("span", _objectSpread(_objectSpread({
  css: getStyles$1(props)
}, filterDataAttributes(props)), {}, {
  children: props.children
}));
Inline.propTypes = process.env.NODE_ENV !== "production" ? {
  scale: _pt.oneOf(['xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl']).isRequired,
  alignItems: _pt.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline', 'flexStart', 'flexEnd']).isRequired,
  justifyContent: _pt.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly']).isRequired,
  children: _pt.node.isRequired
} : {};
const defaultProps = {
  scale: 's',
  alignItems: 'flex-start',
  justifyContent: 'flex-start'
};
Inline.defaultProps = defaultProps;
Inline.displayName = 'Inline';
var Inline$1 = Inline;

// NOTE: This string will be replaced on build time with the package version.
var version = "19.18.0";

export { Inline$1 as default, version };
